import { useSelector } from "react-redux";
import { getAccountState } from "../../redux/slices/accountSlice";
import { Colors } from "../../utils/colors";
import { Icon } from "@iconify/react";
import { CopyableLinkDisplay } from "../Links/CopyCustomLinkify";
import { formatPhoneNumber } from "../../utils/FormatPhoneNumber";
import { TwilioPhoneVerificationStatus } from "@markit/common.types";
import { useMemo } from "react";
import VerificationAccountStatusItem from "../CreatorDashboard/VerificationAccountStatusItem";
import {
  hasSubscription,
  userPhoneVerificationStatus,
} from "@markit/common.utils";
import { useNavigate } from "react-router-dom";
import { NavigationId } from "../../navigation/AppParamList";
import { HorizontalDivider } from "../Dividers/HorizontalDivider";

const ShareMarkitNumber = () => {
  const { accountData } = useSelector(getAccountState).account;
  const navigate = useNavigate();

  const notApprovedAccountStatus = useMemo(
    () =>
      userPhoneVerificationStatus(accountData) !==
      TwilioPhoneVerificationStatus.APPROVED,
    [accountData]
  );

  if (!hasSubscription(accountData)) {
    return null;
  }

  return (
    <>
      <HorizontalDivider altMargin={0} />
      <div className="ColumnNormal" style={{ gap: 14 }}>
        <div className="ColumnNormal" style={{ paddingInline: 14 }}>
          <div className="AlignedRow" style={{ gap: 10 }}>
            <span className="sectionTitle">Share Number</span>
            <Icon icon="ion:call" height={20} />
          </div>
        </div>
        <div className="ColumnNormal" style={{ paddingInline: 14 }}>
          {notApprovedAccountStatus ? (
            <VerificationAccountStatusItem
              expanded
              onPress={() => navigate(NavigationId.HOME_ACCOUNT_STATUS)}
            />
          ) : (
            <CopyableLinkDisplay
              copyText={formatPhoneNumber(accountData.customer.phone)}
              containerStyles={{
                display: "flex",
                padding: 14,
                backgroundColor: Colors.GRAY6,
                borderColor: Colors.GRAY1,
                borderWidth: 0.5,
              }}
              altTextColor={Colors.BLACK}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ShareMarkitNumber;
